import { Platform } from './Platform';
import { Solutions } from './Solutions';
import { Resources } from './Resources';
import { OurData } from './OurData';
import { Pricing } from './Pricing';

export const useNavigationMenu = () => {
  const platformMenu = Platform();
  const solutionsMenu = Solutions();
  const ourDataMenu = OurData();
  const resourcesMenu = Resources();
  const pricingMenu = Pricing();

  return [platformMenu, solutionsMenu, ourDataMenu, resourcesMenu, pricingMenu];
};
